import { Role, SchoolCandidateResidenceChangeSearch } from "../../../models";

export const DEFAULT_FILTERS: SchoolCandidateResidenceChangeSearch = {
  addedSchoolCandidates: false,
  unassignedSchoolCandidates: false,
  notCandidatesForEnrollment: false,
  delayPreviousYear: false,
  hasRequest: null,
  addressApproved: null,
  institutionIds: null,
  page: 1,
  pageSize: 10,
  schoolYearId: 0,
  processedAt: null,
  firstName: null,
  lastName: null,
  oib: null,
  newResidenceInDifferentCounty: false,
};

export const ROLES_DEFAULT_FILTERS = [
  Role.CountyAdministrator,
  Role.CountyLeader,
];
